define('flight-components/Router',['require','App','URIjs/URI','cookies','flight/lib/component'],function(require) {

  var App = require('App'),
      URI = require('URIjs/URI'),
      cookies = require('cookies');

  return require('flight/lib/component')(dataQueryManager);


  function dataQueryManager() {

    this.defaultAttrs({

    });



    this.serveNewWindow = function(ev, data) {
      var url = URI(data.url);
      url.addQuery(data.params || {});
      window.open(url, '_blank');
      this.trigger('uiNewWindowServed', data);
    };

    this.serveReplacedWindow = function(ev, data) {
      window.location.href = data.url;
    };




    // Perform a new keyword/geo query for a given criteria
    //
    this.queryCoupons = function(ev, criteria) {

      // combined any existing search criteria with new criteria
      var newParams = criteria;
      var existingParams = App.results.currentQueryParams;
      var combinedParams = $.extend(existingParams, newParams);

      // check if we need to append a category id
      if (App.results.category != 0) {
        combinedParams.cat = App.results.category
      }

      if (App.page.substring(0, 9) == 'promotion') {
        // The URL for promotion geo queries
        var queryUrl = URI(window.location.href.replace(window.location.search,''));

        // Add parameter to base query URL
        queryUrl = queryUrl + '?changeGeo=' + combinedParams.geo;
      }
      else {
        // The URL for keyword/geo queries
        var queryUrl = URI(App.context + '/query');

        // Add parameters to base query URL
        queryUrl.addSearch(combinedParams);
      }

      // Request for current page to be replaced with page at query URL
      this.trigger(document, 'uiReplaceWindowRequested', {url: queryUrl});
    };


    this.after('initialize', function() {
      this.on('uiCouponQueryRequested', this.queryCoupons);
      this.on('uiNewWindowRequested', this.serveNewWindow);
      this.on('uiReplaceWindowRequested', this.serveReplacedWindow);
    });

  };
});

